import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=fda546d0&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda546d0",
  null
  
)

export default component.exports